import type { FaireThemeEntity } from "../../entity_types/theme";

export const boho_chic_statement_rings: FaireThemeEntity = {
  token: "boho-chic-statement-rings",
  type: "theme",
  name: "Boho-Chic Statement Rings",
  description: "Stackable and statement rings featuring bohemian, vintage, and artistic designs.",
  teaser: "Stackable boho rings perfect for counter displays.",
  detail: "You frequently purchase Bohemian and Vintage rings, particularly from Flanerie by MAIQ. High volume of Cocktail/Statement and Band/Stacked rings including the Sabine and Lulora models.",
  bgColor: "#F5F0D4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ut3tbs6mrw",
    "p_ufjavmwa64",
    "p_nrg5hxcuy3",
    "p_ar6ja253qt",
    "p_ykcapkuvqq",
    "p_7aj8n8fwkr",
    "p_5gefr7p29d",
    "p_9pm84vbjg7",
    "p_s5kj5vxsjg",
    "p_mrdc3wmdh2",
    "p_zbfwgazcex",
    "p_ychfn8hrk4",
    "p_bagjhpjgk4",
    "p_s64zjtkks2",
    "p_kdz9fw5mq5",
    "p_88qwxx7dga",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
